module.exports = __webpack_public_path__ + "static/media/Colette Curve Single Headboard - 120 cm_Grey.1d7eb8fa.png";